export const addresses_routes = [
  {
    path: "/addresses",
    component: () => import("../Main.vue"),
    name: "Endereços"
  }
];

export default {};
